import React from 'react';

export const handleTableSubmitStopPropagation =
  (submitHandler: () => Promise<unknown>) => async (event: React.FormEvent<HTMLFormElement>) => {
    event.stopPropagation();
    event.preventDefault();
    await submitHandler();
  };
